import type { Step } from "react-joyride";

export const payrollByPeriodTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ສະແດງເງິນເດືອນຕາມເດືອນທີ່ເລືອກ. ທ່ານສາມາດປ່ຽນປີ/ເດືອນ, ກັ່ນຕອງຕາມພະແນກ ແລະ ສະຖານະ, ເບິ່ງລາຍລະອຽດ ຫຼື ໃບ slip.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="payroll-period-toolbar"]',
    content:
      "ກັບໄປລາຍການເງິນເດືອນ ຫຼື ສ້າງລາຍການເງິນເດືອນໃໝ່ສຳລັບເດືອນນີ້. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-period-summary"]',
    content:
      "ສະຫຼຸບເງິນເດືອນທັງເດືອນ: ລວມທີ່ຊຳລະແລ້ວ, ລໍຖ້າອະນຸມັດ ແລະ ເງິນເດືອນຮ່າງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-period-filters"]',
    content:
      "ເລືອກປີ, ເດືອນ, ພະແນກ, ສະຖານະ ແລະ ຄົ້ນຫາພະນັກງານເພື່ອກັ່ນຕອງລາຍການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-period-table"]',
    content:
      "ຕາຕະລາງເງິນເດືອນໃນເດືອນນີ້. ກົດ 'ລາຍລະອຽດ' ເພື່ອແກ້ໄຂ ຫຼື 'ໃບ slip' ເພື່ອເບິ່ງ/ພິມໃບຊຳລະ.",
    placement: "top",
  },
];
